module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.device) ? _c('div', {
    class: [( _obj = {}, _obj['bg_' + (_vm.characterSelect + 1)] = _vm.moSceneStep !== '' && _vm.moSceneStep !== 'selectCharacter', _obj ), {
      'bgMask': _vm.moSceneStep === 'help' || _vm.moSceneStep === 'ending'
    }],
    attrs: {
      "id": "MobileGame"
    }
  }, [(_vm.moSceneStep === 'selectCharacter') ? _c('div', {
    staticClass: "selectCharacter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:touchstart",
      value: (_vm.onTouchStart),
      expression: "onTouchStart",
      arg: "touchstart"
    }, {
      name: "touch",
      rawName: "v-touch:touchmove",
      value: (_vm.onTouchMove),
      expression: "onTouchMove",
      arg: "touchmove"
    }],
    staticClass: "characterList",
    attrs: {
      "id": "slider"
    }
  }, _vm._l((_vm.character), function(item, index) {
    return _c('div', {
      staticClass: "characterUnit",
      class: [{
        'selected': index === 0
      }, _vm.character[index].className]
    }, [_vm._m(1, true), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "dialog"
    }, [_c('p', {
      class: {
        'oneLine': !item.dialogLine2
      }
    }, [_vm._v(_vm._s(item.dialogLine1))]), _vm._v(" "), (item.dialogLine2) ? _c('p', [_vm._v(_vm._s(item.dialogLine2))]) : _vm._e()])])
  })), _vm._v(" "), (_vm.nowShowCharacter !== 0) ? _c('span', {
    staticClass: "btn arrow prev",
    on: {
      "click": _vm.prevcharacter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nowShowCharacter !== _vm.character.length - 1) ? _c('span', {
    staticClass: "btn arrow next",
    on: {
      "click": _vm.nextcharacter
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "hintSwitch"
  }, [_vm._v("請左右切換選擇角色")]), _vm._v(" "), _c('button', {
    staticClass: "btn confirm",
    on: {
      "click": _vm.chosecharacter
    }
  }, [_c('span', [_vm._v("搶發財金")])])]) : _vm._e(), _vm._v(" "), (_vm.moSceneStep === 'help') ? _c('div', {
    staticClass: "help"
  }, [(_vm.helpStep !== 2) ? _c('div', {
    staticClass: "hint"
  }, [_c('div', {
    staticClass: "dialog"
  }, [(_vm.helpStep === 0) ? _c('p', [_vm._v("左右擺動手機"), _c('br'), _vm._v("即可控制人物移動!")]) : _vm._e(), _vm._v(" "), (_vm.helpStep === 1) ? _c('p', [_vm._v("來練習一下"), _c('br'), _vm._v("接住發財金吧")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.helpStep === 0) ? _c('div', {
    staticClass: "helpStep helpStep1"
  }, [_c('div', {
    staticClass: "hintPic"
  })]) : _vm._e(), _vm._v(" "), (_vm.helpStep === 1) ? _c('div', {
    staticClass: "helpStep helpStep2"
  }) : _vm._e(), _vm._v(" "), (_vm.helpStep === 2) ? _c('div', {
    staticClass: "helpStep helpStep3"
  }, [_vm._m(2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.moSceneStep === 'mainGame') ? _c('div', {
    staticClass: "mainGame"
  }, [_c('div', {
    staticClass: "timer"
  }, [_vm._v("00:"), ((_vm.nowProgress / 1000).toFixed(0) <= 9) ? _c('span', [_vm._v("0")]) : _vm._e(), _vm._v(_vm._s((_vm.nowProgress / 1000).toFixed(0)))]), _vm._v(" "), _c('div', {
    staticClass: "scoreboard"
  }, [_vm._v("$" + _vm._s(_vm.totalPoint))]), _vm._v(" "), _c('div', {
    staticClass: "startCountDown"
  }, _vm._l((_vm.startCountDownTxt), function(item, index) {
    return _c('p', [_vm._v(_vm._s(item))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.moSceneStep === 'ending') ? _c('div', {
    staticClass: "ending"
  }, [_c('div', {
    staticClass: "outcome"
  }, [_c('p', {
    staticClass: "textHint"
  }, [_vm._v("發財金不夠？再撈一筆！")]), _vm._v(" "), _c('div', {
    staticClass: "outcomeBox"
  }, [_c('div', {
    staticClass: "pic",
    class: 'outcome_' + (_vm.characterSelect + 1) + '-' + (_vm.characterState + 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "totalMoney"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("恭喜獲得發財金")]), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_c('span', [_vm._v("$")]), _vm._v(" " + _vm._s(_vm.totalPoint))])])]), _vm._v(" "), _c('div', {
    staticClass: "btnSection"
  }, [_c('span', {
    staticClass: "btn replay",
    on: {
      "click": _vm.replay
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "39px",
      "height": "39px",
      "viewBox": "0 0 39 39",
      "enable-background": "new 0 0 39 39",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M24.389,20.723c0,2.698-2.188,4.889-4.889,4.889c-2.699,0-4.889-2.19-4.889-4.889 c0-2.702,2.189-4.889,4.889-4.889v2.444l6.355-4.889L19.5,8.5v2.444c-5.398,0-9.777,4.377-9.777,9.778 c0,5.398,4.379,9.777,9.777,9.777s9.777-4.379,9.777-9.777H24.389z"
    }
  })]), _c('span', {
    staticClass: "text"
  }, [_vm._v("再撈一筆")])]), _vm._v(" "), _c('a', {
    staticClass: "btn fbShare",
    attrs: {
      "target": "_blank",
      "href": 'http://www.facebook.com/sharer.php?u=http://2018ny.sobo.com.tw/static/fb/outcome-' + _vm.character[_vm.characterSelect].className + '_' + (_vm.characterState + 1) + '.html'
    },
    on: {
      "click": _vm.fbShare
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "39px",
      "height": "39px",
      "viewBox": "0 0 39 39",
      "enable-background": "new 0 0 39 39",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M24.802,20.509l0.528-4.089h-4.049v-2.61c0-1.184,0.33-1.99,2.027-1.99l2.163-0.002V8.161 C25.099,8.112,23.814,8,22.317,8c-3.122,0-5.258,1.906-5.258,5.405v3.015h-3.531v4.089h3.531V31h4.222V20.509H24.802z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn lineShare",
    attrs: {
      "target": "_blank",
      "href": "http://line.naver.jp/R/msg/text/?2018%E6%97%BA%E6%97%BA%E5%B9%B4%EF%BC%8C%E6%8B%BF%E5%87%BA%E4%BD%A0%E7%9A%84%E6%89%8B%E6%A9%9F%E9%80%A3%E5%8B%95%E9%9B%BB%E8%85%A6%EF%BC%8C%E6%90%B6%E7%99%BC%E8%B2%A1%E9%87%91%E9%81%8E%E5%A5%BD%E5%B9%B4%E3%80%82http://2018ny.sobo.com.tw&from=line_scheme&2018%E6%97%BA%E6%97%BA%E5%B9%B4%EF%BC%8C%E6%8B%BF%E5%87%BA%E4%BD%A0%E7%9A%84%E6%89%8B%E6%A9%9F%E9%80%A3%E5%8B%95%E9%9B%BB%E8%85%A6%EF%BC%8C%E6%90%B6%E7%99%BC%E8%B2%A1%E9%87%91%E9%81%8E%E5%A5%BD%E5%B9%B4%E3%80%82http://2018ny.sobo.com.tw"
    },
    on: {
      "click": _vm.lineShare
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "39px",
      "height": "39px",
      "viewBox": "0 0 39 39",
      "enable-background": "new 0 0 39 39",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M19.5,8c-6.655,0-12.069,4.394-12.069,9.794c0,4.842,4.293,8.897,10.094,9.664 c0.393,0.085,0.928,0.26,1.063,0.596c0.121,0.305,0.079,0.783,0.038,1.091c0,0-0.142,0.852-0.172,1.033 c-0.053,0.306-0.242,1.193,1.046,0.65c1.288-0.542,6.95-4.093,9.482-7.007c1.749-1.918,2.587-3.865,2.587-6.027 C31.569,12.394,26.155,8,19.5,8z M15.241,20.679c0,0.129-0.104,0.235-0.234,0.235h-3.382h-0.001c-0.063,0-0.12-0.025-0.162-0.066 c-0.001-0.001-0.002-0.002-0.003-0.003c-0.002-0.001-0.003-0.002-0.004-0.004c-0.04-0.042-0.065-0.099-0.065-0.162v-5.259 c0-0.129,0.105-0.235,0.235-0.235h0.847c0.13,0,0.234,0.105,0.234,0.235v4.177h2.301c0.13,0,0.234,0.105,0.234,0.235V20.679z M17.282,20.679c0,0.13-0.105,0.234-0.234,0.234h-0.847c-0.13,0-0.235-0.104-0.235-0.234v-5.259c0-0.129,0.105-0.235,0.235-0.235 h0.847c0.129,0,0.234,0.105,0.234,0.235V20.679z M23.109,20.679c0,0.13-0.105,0.234-0.235,0.234h-0.847 c-0.021,0-0.041-0.003-0.06-0.008c-0.001,0-0.003-0.001-0.004-0.001c-0.005-0.001-0.01-0.003-0.016-0.005 c-0.003-0.001-0.005-0.002-0.007-0.003c-0.005-0.001-0.008-0.003-0.012-0.005c-0.004-0.001-0.008-0.003-0.012-0.005 c-0.002-0.002-0.004-0.002-0.006-0.004c-0.005-0.003-0.01-0.006-0.015-0.009c-0.001-0.001-0.002-0.001-0.003-0.002 c-0.021-0.015-0.043-0.034-0.06-0.058l-2.412-3.26v3.124c0,0.13-0.105,0.234-0.235,0.234h-0.847c-0.13,0-0.235-0.104-0.235-0.234 v-5.259c0-0.129,0.105-0.235,0.235-0.235h0.847c0.003,0,0.005,0,0.008,0c0.004,0,0.009,0,0.012,0.001c0.005,0,0.009,0,0.013,0.001 c0.004,0,0.007,0,0.01,0.001c0.005,0.001,0.01,0.002,0.014,0.003c0.003,0,0.006,0.001,0.008,0.002 c0.005,0.001,0.01,0.003,0.015,0.004c0.003,0.001,0.005,0.002,0.008,0.003c0.005,0.001,0.009,0.003,0.014,0.006 c0.002,0.001,0.005,0.002,0.007,0.003c0.004,0.002,0.009,0.004,0.013,0.007c0.002,0.001,0.005,0.002,0.007,0.004 c0.004,0.002,0.009,0.005,0.013,0.008c0.002,0.001,0.004,0.003,0.006,0.005c0.004,0.003,0.009,0.007,0.013,0.01 c0.001,0.001,0.003,0.003,0.004,0.004c0.005,0.005,0.01,0.009,0.015,0.015l0.001,0.001c0.007,0.008,0.013,0.016,0.019,0.024 l2.41,3.255v-3.125c0-0.129,0.104-0.235,0.234-0.235h0.847c0.13,0,0.235,0.105,0.235,0.235V20.679z M27.784,16.267 c0,0.13-0.104,0.235-0.234,0.235h-2.301v0.889h2.301c0.13,0,0.234,0.105,0.234,0.235v0.847c0,0.13-0.104,0.235-0.234,0.235h-2.301 v0.889h2.301c0.13,0,0.234,0.105,0.234,0.235v0.847c0,0.129-0.104,0.235-0.234,0.235h-3.382h-0.001 c-0.063,0-0.12-0.025-0.162-0.066c-0.001-0.001-0.003-0.002-0.003-0.003c-0.002-0.001-0.003-0.002-0.004-0.004 c-0.04-0.042-0.065-0.099-0.065-0.162V15.42v0c0-0.063,0.024-0.12,0.065-0.162c0.001-0.001,0.002-0.003,0.004-0.004 c0-0.001,0.001-0.001,0.002-0.002c0.043-0.041,0.1-0.066,0.163-0.066h0.001h3.382c0.13,0,0.234,0.105,0.234,0.235V16.267z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "linkSection"
  }, [_c('a', {
    staticClass: "logoSobo",
    attrs: {
      "target": "_blank",
      "href": "http://www.sobo.com.tw/design/"
    },
    on: {
      "click": _vm.openSobo
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/link-sobo.png",
      "alt": "SOBO 淞泊創意設計"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "logoWeddings",
    attrs: {
      "target": "_blank",
      "href": "http://www.weddings.tw/"
    },
    on: {
      "click": _vm.openWedding
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/link-weddings.png",
      "alt": "Weddings 新娘物語"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.moSceneStep === 'help' || _vm.moSceneStep === 'mainGame') ? _c('div', {
    staticClass: "gameItem",
    style: ({
      width: _vm.sceneWidth + 'px',
      marginLeft: _vm.sceneWidth / -2 + 'px',
    })
  }, [(_vm.moSceneStep === 'help') ? _c('div', {
    staticClass: "demoTreasure"
  }, _vm._l((_vm.demoFallingTreasure), function(item, index) {
    return _c('div', {
      staticClass: "treasure",
      class: _vm.demoFallingTreasure[index][0],
      style: ({
        width: _vm.demoFallingTreasure[index][2][0] / 2 + 'px',
        height: _vm.demoFallingTreasure[index][2][1] / 2 + 'px',
        top: '-10%'
      }),
      attrs: {
        "data-point": _vm.demoFallingTreasure[index][1]
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.moSceneStep === 'mainGame') ? _c('div', {
    staticClass: "treasureGroup"
  }, _vm._l((_vm.fallingTreasureList), function(item, index) {
    return _c('div', {
      staticClass: "treasure",
      class: [_vm.fallingTreasureList[index][0], 'tIndex_' + (index + 1)],
      style: ({
        width: _vm.fallingTreasureList[index][2][0] / 2 + 'px',
        height: _vm.fallingTreasureList[index][2][1] / 2 + 'px',
        top: '-10%'
      }),
      attrs: {
        "data-point": _vm.fallingTreasureList[index][1]
      }
    })
  })) : _vm._e(), _vm._v(" "), ((_vm.moSceneStep === 'help' && _vm.helpStep !== 2) || (_vm.moSceneStep !== 'help' && _vm.moSceneStep !== 'ending')) ? _c('div', {
    staticClass: "treasureCore",
    class: {
      'notOnRoof': _vm.moSceneStep === 'help' || _vm.moSceneStep === 'mainGame'
    },
    style: ({
      width: _vm.treasureBoxWidth + 'px',
      height: _vm.treasureBoxHeight + 'px',
      top: 0,
      left: ((_vm.sceneWidth - _vm.treasureBoxWidth) / 2 - 100) + 'px',
    })
  }) : _vm._e(), _vm._v(" "), ((_vm.moSceneStep === 'help' && _vm.helpStep === 1) || _vm.moSceneStep === 'mainGame') ? _c('div', {
    staticClass: "avatar",
    class: [_vm.character[_vm.characterSelect].className, 'state_' + (_vm.characterState + 1)],
    style: ({
      marginLeft: 'auto',
      width: _vm.character[_vm.characterSelect].avatarSize[_vm.characterState].width / 2 + 'px',
      height: _vm.character[_vm.characterSelect].avatarSize[_vm.characterState].height / 2 + 'px',
      transform: 'translateX(' + _vm.data + 'px)',
      MozTransform: 'translateX(' + _vm.data + 'px)',
      WebkitTransform: 'translateX(' + _vm.data + 'px)',
      msTransform: 'translateX(' + _vm.data + 'px)'
    })
  }, [_c('div', {
    staticClass: "valueHint"
  }, [_vm._v("+ " + _vm._s(_vm.getValue) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.moSceneStep === 'help' || _vm.moSceneStep === 'mainGame') ? _c('div', {
    staticClass: "block",
    class: [{
      'popout': _vm.blockCoordinate
    }, _vm.character[_vm.randomBlock].className, 'state_' + (_vm.randomBlockState + 1)],
    style: ({
      width: _vm.character[_vm.randomBlock].avatarSize[_vm.randomBlockState].width / 2 + 'px',
      height: _vm.character[_vm.randomBlock].avatarSize[_vm.randomBlockState].height / 2 + 'px',
      left: (_vm.blockLastCoordinate + _vm.sceneWidth / 2) + 'px',
      marginLeft: _vm.character[_vm.randomBlock].avatarSize[_vm.randomBlockState].width / -4 + 'px',
      paddingBottom: '15px'
    })
  }) : _vm._e()]) : _vm._e()]) : _c('div', {
    staticClass: "redirect"
  }, [_c('div', {
    staticClass: "alert"
  }, [_c('div', {
    staticClass: "alertBox"
  }, [_c('p', {
    staticClass: "text alertType"
  }, [_vm._v("請回首頁")]), _vm._v(" "), _c('p', {
    staticClass: "text alertText"
  }, [_vm._v("重新開始遊戲")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/',
      "replace": ""
    }
  }, [_c('span', [_vm._v("確定")])])], 1)]), _vm._v(" "), (!_vm.device) ? _c('router-link', {
    attrs: {
      "to": '/',
      "replace": ""
    }
  }, [_vm._v("確定")]) : _vm._e()], 1)
  var _obj;
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sceneTitle"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/mobile/title-chose.png",
      "height": "40",
      "width": "131",
      "alt": "連結裝置"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('div', {
    staticClass: "img"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialogReady"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("等不及發大財了嗎？"), _c('br'), _vm._v("立刻去搶發財金吧！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b8cf933","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileGame.vue
// module id = 447
// module chunks = 0